

const { VUE_APP_INTERCOM_APP_ID } = process.env;

import { getFromLocalStorage } from '@/utils/helpers';
import Intercom from '@intercom/messenger-js-sdk';

export const boot = ({ user }) => {
  const { email } = user;
  const intercomJwtToken = getFromLocalStorage('bq:intercom-token');

  try {
    Intercom({
      app_id: VUE_APP_INTERCOM_APP_ID,
      email,
      intercom_user_jwt: intercomJwtToken
    });
  } catch (error) {
    console.error('failed to start intercom', error);
  }
};

export const shutdown = () => {
  try {
    Intercom.shutdown();
  } catch (error) {
    console.error('failed to shutdown intercom', error);
  }
};